(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('RefereeList', RefereeList);

  function RefereeList($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/licences');
  }
}());
